import * as R from 'remeda';
import { RealtimeAction, RealtimeState } from 'store/page/realtime';
import { timeUtility } from 'utility';

const selectedDay: Time.Day = {
  id: timeUtility.generateDayId(2025, 11, 1),
  type: 'day',
  year: 2025,
  month: 11,
  dayOfWeek: 1,
  dayOfMonth: 1,
  week: 1,
};

const initialState: RealtimeState = {
  selectedDay,
};

const realtimeReducer = (
  state: RealtimeState = initialState,
  action: RealtimeAction,
): RealtimeState => {
  switch (action.type) {
    case 'page/realtime/SET_SELECTED_DAY':
      return R.set(state, 'selectedDay', action.payload);
    default:
      return state;
  }
};

export default realtimeReducer;
